<template>
  <div class="animated fadeIn">
    <b-row class="justify-content-center" v-if="showList">
      <b-col md="10" lg="8">
        <b-card v-show="showList">
          <div slot="header">
            Kota Layanan
            <div class="card-header-actions">
              <b-button variant="btn btn-primary mr-1" @click="add">Add</b-button>
              <button class="btn btn-danger mr-1" @click="close()">
                <i class="fa fa-close"></i> Close
              </button>
            </div>
          </div>
          <b-table
            class="mb-0"
            ref="table"
            outlined
            responsive
            hover
            small
            style="font-size:smaller;"
            :items="data"
            :fields="tblFields"
            :current-page="tblData.page"
            :per-page="tblData.limit"
            :sort-by.sync="tblData.sortBy"
            :sort-desc.sync="tblData.sortDesc"
            @row-clicked="rowClicked"
          >
            <template v-slot:cell(hrg_agen_ecer)="data">{{data.item.hrg_agen_ecer|numFormat}}</template>

            <template v-slot:cell(action)="data">
              <div class="text-center">
                <a href="javascript:void(0)" @click.stop="edit(data.item)">
                  <i class="fa fa-pencil"></i>
                </a>
                |
                <a
                  href="javascript:void(0)"
                  class="text-danger"
                  @click.stop="deleteConfirm(data.item)"
                >
                  <i class="fa fa-trash"></i>
                </a>
              </div>
            </template>
          </b-table>
          <b-row class="mt-2">
            <b-col cols="6">
              <div>
                Showing {{(tblData.page - 1) * tblData.limit + 1}}
                to
                <span
                  v-if="((tblData.page * tblData.limit)>tblData.total)"
                >{{tblData.total}}</span>
                <span v-else>{{tblData.page * tblData.limit}}</span>
                of {{tblData.total}} entries
              </div>
            </b-col>
            <b-col cols="6">
              <b-pagination
                align="right"
                :total-rows="tblData.total"
                :per-page="tblData.limit"
                v-model="tblData.page"
              ></b-pagination>
            </b-col>
          </b-row>

          <b-modal v-model="showDelConfirm" title="Delete Record?" :centered="true" @ok="deleteData">
            <p class="mb-1">1 record is about to be permanently deleted</p>
            <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
          </b-modal>
        </b-card>
      </b-col>
    </b-row>
    <b-row class="justify-content-center" v-if="showForm">
      <b-col md="7" lg="6">
        <b-card>
          <div slot="header">Kota Layanan - Add/Edit Form</div>
          <b-input-group>
            <b-input-group-prepend>
              <label>Nama Kota</label>
            </b-input-group-prepend>
            <b-form-input v-model="frmdata.kota_name" :state="!$v.frmdata.kota_name.$error"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Group/Area</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.area_name"
              @keyup.13.native="lkuKoranAreaShow=true"
              placeholder="Pilih Group/Area"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button"  @click="lkuKoranAreaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>
          <b-input-group class="mr-4">
            <b-input-group-prepend >
              <label>Harga Eceran</label>
            </b-input-group-prepend>
            <b-input-group-prepend>
              <span class="input-group-text pl-4 pr-4">{{uanguser}}</span>
            </b-input-group-prepend>
            <my-number
              class="form-control text-right"
              separator=","
              v-model="frmdata.hrg_agen_ecer"
              :state="!$v.frmdata.hrg_agen_ecer.$error"
              :precision="2"
            ></my-number>
          </b-input-group>

          <b-input-group>
            <b-input-group-prepend>
              <label>Sales/AE</label>
            </b-input-group-prepend>
            <b-form-input
              readonly
              v-model="model.salesae_name"
              @keyup.13.native="lkuKoranAreaShow=true"
              placeholder="Pilih Sales/AE"
            ></b-form-input>
            <b-input-group-append>
              <b-btn text="Button"  @click="lkuKoranAreaShow=true">
                <i class="fa fa-search"></i>
              </b-btn>
            </b-input-group-append>
          </b-input-group>

          <div slot="footer" style="text-align:center;">
            <button class="btn btn-primary mr-1" @click="save()">
              <i class="fa fa-save"></i> Save
            </button>
            <b-button variant="secondary" class="mr-1" @click="closeFrm()">
              <i class="fa fa-close"></i> Close Form
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
    <b-modal v-model="lkuKoranSalesShow" size="lg" :hide-footer="true" title="List of Sales" :centered="true">
      <lku-salesae @click="onSelectSalese" crudfilter="koran=1"></lku-salesae>
    </b-modal>
    <b-modal v-model="lkuKoranAreaShow" size="md" :hide-footer="true" title="List of Area/Group" :centered="true">
      <lku-area @click="onSelectArea" ></lku-area>
    </b-modal>

  </div>
</template>


<script>
import toastr from "mini-toastr";
import crud from "../../apis/crud";
import myNumber from "../../components/my-number";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import lkuSalesae from "../lookup/lkuSalesae";
import lkuArea from "../lookup/lkuKoranArea";

toastr.init();

export default {
  components: {myNumber,lkuSalesae, lkuArea},
  mixins: [validationMixin],
  validations: {
    frmdata: {
      kota_name: { required },
      area_id: { required },
      hrg_agen_ecer: {required}
    }
  },
  data() {
    return {
      showDelConfirm: false,
      horizontal: true,
      showList: true,
      showForm: false,
      lkuKoranAreaShow: false,
      lkuKoranSalesShow: false,
      uanguser: this.$store.state.user.matauang,
      frmdata: { kota_name: "", area_id: "", salesae_id:'', hrg_agen_ecer:0 },
      areas: [],
      tblData: {
        tablename: "vwkorankota",
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "kota_name",
        sortDesc: false
      }
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "kota_name",
          label: "Nama Kota  layanan",
          sortable: true
        },
        {
          key: "area_name",
          label: "Group/Area",
          sortable: true
        },
        {
          key: "salesae_name",
          label: "Sales/AE",
          sortable: true
        },
        {
          key: "hrg_agen_ecer",
          label: "Harga ",
          sortable: true
        },
        {
          key: "action",
          label: "Action",
          thStyle: "width:60px",
          thClass: "text-center"
        }
      ];
      return fields;
    },
    invalidFormdata() {
      this.$v.frmdata.$touch();
      return this.$v.frmdata.$invalid;
    }
  },
  // created: async function() {
  //   const a = await crud.list({
  //     tablename: "koranarea",
  //     page: 1,
  //     limit: 1000,
  //     total: 0,
  //     sortBy: "area_name",
  //     sortDesc: false
  //   });
  //   this.areas = a.reduce((newArr, item) => {
  //     newArr.push({ value: item.area_id, text: item.area_name });
  //     return newArr;
  //   }, []);
  // },
  methods: {
    onSelectSalese: async function(_sales) {
      this.model.salesae_id = _sales.salesae_id;
      this.model.salesae_name = `${_sales.crewname || _sales.salesae_name}`;
      this.lkuKoranSalesShow = false;
    },
    onSelectArea: async function(_selected) {
      this.model.area_id = _selected.area_id;
      this.model.area_name = _selected.area_name;
      this.lkuKoranAreaShow = false;
    },

    data: async function(ctx) {
      this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";

      const list = await crud.list(this.tblData);
      return list;
    },
    refresh(ctx) {
      if (this.$refs.table) this.$refs.table.refresh();
    },
    add: function(data) {
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      this.showForm = true;
      this.showList = false;
    },
    edit: async function(data) {
      this.model = data;
      for (var key in this.frmdata) {
        this.frmdata[key] = "";
      }
      for (var key in this.model) {
        this.frmdata[key] = this.model[key];
      }
      this.frmdata.idlama = data.kota_id;
      this.showForm = true;
      this.showList = false;
    },
    save: async function(callback) {
      if (this.invalidFormdata) {
        console.log("validation : ", this.$v.frmdata);
        console.log("frmdata : ", this.frmdata);
        toastr.error("Please fill the form correctly.", "ERROR MESSAGE");
      } else {
        try {
          if (this.frmdata.idlama) {
            await crud.update({
              tablename: "korankota",
              key: this.frmdata.idlama,
              data: {
                kota_name: this.frmdata.kota_name,
                kota_code: this.frmdata.kota_code,
                area_id: this.frmdata.area_id,
                salesae_id: this.frmdata.salesae_id,
                hrg_agen_ecer: this.frmdata.hrg_agen_ecer
              }
            });
          } else {
            await crud.insert({
              tablename: "korankota",
              data: {
                kota_name: this.frmdata.kota_name,
                kota_code: this.frmdata.kota_code,
                area_id: this.frmdata.area_id,
                salesae_id: this.frmdata.salesae_id,
                hrg_agen_ecer: this.frmdata.hrg_agen_ecer
              }
            });
          }
          this.closeFrm();
          setTimeout(() => {
            this.refresh();
          }, 500);
        } catch (error) {
          if (error.message) {
            toastr.error(error.message);
          } else {
            toastr.error(JSON.stringify(error));
          }
        }
      }
    },
    deleteConfirm(item) {
      this.model = item;
      this.showDelConfirm = true;
    },
    deleteData: async function() {
      await crud.remove({
        tablename: "koran_kota",
        key: this.model.kota_id
      });
      this.refresh();
    },
    rowClicked(record, index) {
      if (this.model && this.model._rowVariant) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = "info";
      this.$forceUpdate();
    },
    closeFrm() {
      this.showForm = false;
      this.showList = true;
    },
    close() {
      router.push({name: "koran.home"});
    }
  }
};
</script>
